import React, { Component } from 'react'
import { withTranslation, Trans } from 'react-i18next'
import { ReactSVG } from 'react-svg'
import ForbiddenVector from './403-forbidden.svg'
import logoMD from '@resources/assets/img/login-logo.png'
import './SplashScreen.scss'

class PageForbidden extends Component {
  render() {
    return (
      <div className="splash-screen" style={styles.container}>
        <img style={styles.waterMark} src={logoMD} alt="splashImageWatermark" />
        <div style={styles.leftColumn}>
          <div style={styles.largeText}>403</div>
          <div style={styles.secondaryText}>
            {' '}
            <Trans>Acceso denegado</Trans>
          </div>
          <div style={{ fontWeight: 600 }}>
            {' '}
            <Trans>No tienes permisos para ver esta página</Trans>
          </div>
        </div>
        <div style={styles.rightColumn}>
          <ReactSVG style={styles.medicalImage} src={ForbiddenVector} />
        </div>
      </div>
    )
  }
}

const styles = {
  container: {
    display: 'flex',
    width: '100%',
    height: 'inherit',
    position: 'relative',
    background: 'aliceblue',
  },
  waterMark: {
    width: 313.7,
    height: 50,
    position: 'absolute',
    top: 40,
    left: 40,
    zIndex: 4,
  },
  medicalImage: {
    width: '80%',
  },
  rightColumn: {
    flex: '0 50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  leftColumn: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    justifyContent: 'center',
    padding: '12px 24px',
    alignItems: 'flex-end',
  },
  largeText: {
    color: '#01a8e7',
    fontSize: 100,
    lineHeight: 'normal',
    fontWeight: 700,
  },
  secondaryText: {
    color: 'black',
    fontSize: 40,
    lineHeight: 'normal',
    fontWeight: 400,
  },
}

export default withTranslation()(PageForbidden)
